import React, { useEffect } from 'react';
import { node } from 'prop-types';
import { Hero } from '@thd-olt-component-react/hero';
import { useHelmet, LinkTag } from '@thd-nucleus/thd-helmet';
import {
  useDataModel,
  params,
  arrayOf,
  string,
  fragment,
  shape,
  extend,
} from '@thd-nucleus/data-sources';

const homepageMetadataHandler = ({ data: { heroImageUrl } }) => {
  return [
    new LinkTag({
      rel: 'preload',
      as: 'image',
      href: heroImageUrl,
      id: 'preloadHeroImage',
    })
  ];
};

const HomepageMetadata = (props) => {
  const { children } = props;

  const queryOptions = {
    variables: {
      slug: 'b2c-homepage-prod'
    }
  };

  const { data: homepageHeroImageData } = useDataModel('layouts', queryOptions);
  const heroImageUrl = homepageHeroImageData?.layouts?.content?.heroCarousel?.components?.[0]?.image?.url;

  useHelmet('homepageMetadataHandler', { props, data: { heroImageUrl } }, homepageMetadataHandler, [heroImageUrl]);
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('metadata.ready'); }, []);

  return (
    children || null
  );
};

const HeroFlattenImage = {};
HeroFlattenImage.dataModel = {
  image: shape({
    contentType: string(),
    description: string(),
    id: string(),
    publishDate: string(),
    title: string(),
    url: string(),
  }),
  __typename: string(),
  link: string(),
  mobileImage: shape({
    contentType: string(),
    description: string(),
    id: string(),
    publishDate: string(),
    title: string(),
    url: string(),
  }),
  title: string(),
};

const heroImageDataModel = extend({
  layouts: params({
    slug: string().isRequired(),
  }).shape({
    content: shape({
      __typename: string(),
      PersonalizedHomePage: fragment().shape({
        heroCarousel: shape({
          components: arrayOf(shape({
            ...Hero.dataModel.component,
            HeroFlattenImage: fragment().shape(HeroFlattenImage.dataModel)
          })),
        }),
      }),
    }),
  }),
},
Hero
);

HomepageMetadata.propTypes = {
  children: node,
};

HomepageMetadata.defaultProps = {
  children: null,
};

HomepageMetadata.dataModel = heroImageDataModel;

export { HomepageMetadata };